import { useMutation, useQueryCache } from "react-query";
import { postRemoveUserFromList } from "../api";
import { notify } from "../../../../../common/helpers";
import { _t } from "../../../../../modules/Common/components/InjectIntlContext";
import { API_KEY_GET_MANAGEABLE_LIST } from "../constants";

export const usePostRemoveUserFromList = () => {
  const queryCache = useQueryCache();
  const successMsg = _t("deleted_successfully");

  return useMutation(postRemoveUserFromList, {
    onSuccess: (data, variables) => {
      notify("success", successMsg);
      queryCache.invalidateQueries(API_KEY_GET_MANAGEABLE_LIST);
    },
  });
};
